import { type EnhancedStore } from '@reduxjs/toolkit';
import { type Logger } from 'loglevel';

export enum Strategy {
  OG = 'OG',
  V2 = 'V2',
}

export type BusinessServiceConfig<StoreType> = {
  serviceName: string;
  store: StoreType & EnhancedStore;
  logger: Logger;
  strategyMap: Record<string, Strategy>;
};

export type ResponseSuccess<T> = {
  data: T;
};

export type BusinessServiceError = unknown;

export type ResponseError = {
  error: BusinessServiceError;
};

export type ResponseWrapper<T> = ResponseSuccess<T> | ResponseError;

export type Store<T> = T & EnhancedStore;
